/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { InteractiveComponents } from '../../../core/enums';
import { RootState, useTivoSelector } from '../../../core/tivo/tivo-redux-wrapper';
import { Caret } from '../../common';

import './InteractiveLayer.scss';

const InteractiveLayer: FunctionComponent = (): JSX.Element => {
    const activeComponent = useTivoSelector(
        (state: RootState) => state.interactiveLayer.activeComponent,
    );
    const { carousels, verticalScrollIndex, focusState, navBarFocused } = useTivoSelector(
        (state: RootState) => state.homeScreen,
    );
    const isCaretVisible = activeComponent !== '';

    // NORTH: visible only when there are carousels above the current focus
    const canScrollNorth = navBarFocused
        ? false
        : focusState.carouselIndex > 0;

    // SOUTH: visible only when there are carousels below the current focus
    const canScrollSouth = navBarFocused
        ? carousels.length > 0
        : focusState.carouselIndex < carousels.length - 1;

    // EAST/WEST carets are now rendered per-carousel inside Carousel.tsx
    return (
        <React.Fragment>
            <Caret
                direction={InteractiveComponents.NORTH}
                visible={
                    isCaretVisible &&
                    activeComponent === InteractiveComponents.NORTH &&
                    canScrollNorth
                }
                active={activeComponent === InteractiveComponents.NORTH}
                className="home-north"
            />
            <Caret
                direction={InteractiveComponents.SOUTH}
                visible={
                    isCaretVisible &&
                    activeComponent === InteractiveComponents.SOUTH &&
                    canScrollSouth
                }
                active={activeComponent === InteractiveComponents.SOUTH}
                className="home-south"
            />
        </React.Fragment>
    );
};

export default InteractiveLayer;
